export default __webpack_public_path__ + "static/media/Sage's Gloves of the Eldritch.426a5cb4.jpg";